<div class="user-chat d-flex bg-secondary-lighter p-3">
    <div class="user-chat-inner">
        @if (userName()) {
            <div class="user-avatar dot dot-34 dot-gray align-self-start">
                <span>{{ userName() }}</span>
            </div>
        } @else {
            <div class="user-avatar dot dot-34 dot-gray align-self-start">
                <span>SM</span>
            </div>
        }
        <div class="flexbox-column gap-8 pt-2 w-auto single-chat">
            @if (chat()?.userPrompt) {
                <p class="msg-body format-text fs-3">{{ chat()?.userPrompt }}</p>
            }
            @if (chat()?.fileAttachments?.length > 0) {
                <ul class="upload-files-list list-style-none">
                    @for (file of chat()?.fileAttachments; track $index) {
                        <li class="card upload-file-card" title="{{ file?.name ? file?.name : file }}">
                            <span class="left-file-icon dot-34 icon-bordered-primary"
                                  style="border-width:4px!important;">
                                <i class="fa-regular fa-file text-primary"></i>
                            </span>
                            <div class="flexbox-column gap-8 chat-file-name">
                                <div class="flexbox-row gap-8 flex-nowrap justify-content-between align-items-start">
                                    <div class="flexbox-column gap-0">
                                        <h6 class="title text-ellipse">{{ file?.name ? file?.name : file }}</h6>
                                    </div>
                                </div>
                            </div>
                        </li>
                    }
                </ul>
            } @else {
                @if (chat()?.userInputFileNames?.length > 0) {
                    <ul class="upload-files-list list-style-none">
                        @for (item of chat()?.userInputFileNames; track $index) {
                            <li class="card upload-file-card" title="{{ item }}">
                                        <span class="left-file-icon dot-34 icon-bordered-primary"
                                              style="border-width:4px!important;">
                                              <i class="fa-regular fa-file text-primary"></i>
                                        </span>
                                <div class="flexbox-column gap-8 chat-file-name">
                                    <div class="flexbox-row gap-8 flex-nowrap justify-content-between align-items-start">
                                        <div class="flexbox-column gap-0">
                                            <h6 class="title text-ellipse">{{ item }}</h6>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        }
                    </ul>
                }
            }
            @if (chat()?.userPrompt) {
                <div class="button-group gap-8">
                    <button mat-button mat-stroked-button color="dark" class="button-smaller" (click)="copyText()"
                            [cdkCopyToClipboard]="chat()?.userPrompt" title="{{hasCopiedText()  ? 'Copied' : 'Copy'}}">
                        <div class="flexbox-row gap-8">
                            <i class="fa-regular fa-clone"></i>
                            <span class="button-label">{{ hasCopiedText() ? 'Copied' : 'Copy' }}</span>
                        </div>
                    </button>
                </div>
            }

        </div>
    </div>
</div>
